// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"19069":"589d8a59a4be3154","20978":"5b6fd6130d55f1ca","55828":"fc2acf5697a30d7c"}[chunkId] + ".css";
};